type CoordData = {
    title:string,
    x:number,
    y:number,
    max:boolean,
}


function parse(xmlString:string):Record<string, CoordData>{
    const parser = new DOMParser();
    const xml = parser.parseFromString(xmlString, 'text/xml');

    var result:Record<string, CoordData> = {};
    var items = xml.getElementsByTagName("item");
    for(var i=0; i < items.length; i++){
        var item = items[i]
        var title = item.getAttribute('title')!
        result[title] = {
            title: title.split(" ").join(""),
            x: parseFloat(item.getAttribute('xPos')!),
            y: parseFloat(item.getAttribute('yPos')!) + 100,
            max: false,
        }
    }

    return result;
}


const coordData = {
    0: {
        ...parse(require('!!raw-loader!./coords/00/level0_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level1_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level2_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level3_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level4_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level5_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level6_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level7_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level8_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level9_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level10_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level11_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level12_00.xml').default),

    },
    16: {
        ...parse(require('!!raw-loader!./coords/16/level0_16.xml').default),
        ...parse(require('!!raw-loader!./coords/16/level1_16.xml').default),
        ...parse(require('!!raw-loader!./coords/16/level2_16.xml').default),
        ...parse(require('!!raw-loader!./coords/16/level3_16.xml').default),
        ...parse(require('!!raw-loader!./coords/16/level4_16.xml').default),
        ...parse(require('!!raw-loader!./coords/16/level5_16.xml').default),
        ...parse(require('!!raw-loader!./coords/16/level6_16.xml').default),
        ...parse(require('!!raw-loader!./coords/16/level7_16.xml').default),
        ...parse(require('!!raw-loader!./coords/16/level8_16.xml').default),
        ...parse(require('!!raw-loader!./coords/16/level9_16.xml').default),
        ...parse(require('!!raw-loader!./coords/16/level10_16.xml').default),
        ...parse(require('!!raw-loader!./coords/16/level11_16.xml').default),

    }
} as Record<number, Record<string, CoordData>>

export default coordData;